/**
 * 搜索相关工具（Liquid 侧对应 snippets/search-query-normalized.liquid）
 *
 * 流程说明：
 * 1. predictive-search.js 提交前：仅多词标题自动加引号（SKU 不加，Shopify 短语搜索对含 &/- 的 SKU 会返回 0）
 * 2. main-search.liquid：对 Shopify 返回结果做 SKU/标题二次精确过滤
 * 3. product-card / product-url-from-search-sku：生成带 ?variant= 的链接
 * 4. search-product-variant-links.js：AJAX 筛选后补全链接（须先 normalize 去掉引号）
 *
 * 注意：任何使用 search.terms / URL q 做 SKU 匹配的地方，都必须先 normalize。
 */
(function () {
  function normalizeSearchQuery(value) {
    let query = value == null ? '' : String(value).normalize('NFC').trim();
    if (query.length >= 2 && query.startsWith('"') && query.endsWith('"')) {
      query = query.slice(1, -1).trim();
    }
    return query.replace(/^"+|"+$/g, '');
  }

  function shouldQuoteSearchQuery(query) {
    if (!query || (query.startsWith('"') && query.endsWith('"'))) return false;
    // SKU（无空格、含 -&_ 等）不要加引号：Shopify 精确短语搜索对此类 SKU 常返回 0
    // 精确命中依赖 main-search.liquid 的二次过滤
    return /\s/.test(query);
  }

  function findVariantBySku(variants, query) {
    const normalizedQuery = normalizeSearchQuery(query).toLowerCase();
    if (!normalizedQuery) return null;

    return (variants || []).find((variant) => {
      const sku = variant?.sku == null ? '' : String(variant.sku).normalize('NFC').trim().toLowerCase();
      return sku && sku === normalizedQuery;
    }) || null;
  }

  window.SearchUtils = {
    normalizeSearchQuery,
    shouldQuoteSearchQuery,
    findVariantBySku,
  };
})();
